import { Collapsible, Stack, TextField, Select, Icon } from "@shopify/polaris";
import { ChevronRightMinor, ChevronUpMinor } from "@shopify/polaris-icons";
import { useEffect, useState } from "react";
import UpgradeTooltip from "../upgrade-tooltip";
import LoopColorPicker from "../color-picker";

function StyleAccordion({
  name,
  input_element,
  index,
  open,
  item = {},
  input_value_json = {},
  input_value_string,
  disabled,
  hasFeature,
  getMinPlanForFeature,
  options = [],
  ...props
}) {
  const fontWeightOptions = [
    {
      label: "none",
      value: "none",
    },
    {
      label: "300",
      value: "300",
    },
    {
      label: "400",
      value: "400",
    },
    {
      label: "500",
      value: "500",
    },
    {
      label: "600",
      value: "600",
    },
    {
      label: "700",
      value: "700",
    },
    {
      label: "800",
      value: "800",
    },
    {
      label: "900",
      value: "900",
    },
  ];
  const sizeType = [
    {
      label: "px",
      value: "px",
    },
    {
      label: "rem",
      value: "rem",
    },
    {
      label: "em",
      value: "em",
    },
    {
      label: "%",
      value: "%",
    },
  ];
  const textAlignList = [
    {
      label: "center",
      value: "center",
    },
    {
      label: "left",
      value: "left",
    },
    {
      label: "right",
      value: "right",
    },
  ];

  const lineBreakOptions = [
    {
      label: "normal",
      value: "normal",
    },
    {
      label: "break-all",
      value: "break-all",
    },
    {
      label: "keep-all",
      value: "keep-all",
    },
    {
      label: "keep-all",
      value: "keep-all",
    },
    {
      label: "initial",
      value: "initial",
    },
    {
      label: "inherit",
      value: "inherit",
    },
  ];

  const textTransformOptions = [
    {
      label: "none",
      value: "none",
    },
    {
      label: "capitalize",
      value: "capitalize",
    },
    {
      label: "lowercase",
      value: "lowercase",
    },
    {
      label: "uppercase",
      value: "uppercase",
    },
  ];

  const fontStyleOptions = [
    {
      label: "unset",
      value: "unset",
    },
    {
      label: "oblique",
      value: "oblique",
    },
    {
      label: "italic",
      value: "italic",
    },
    {
      label: "normal",
      value: "normal",
    },
  ];

  const [ready, setready] = useState(false);
  const [fontSize, setfontSize] = useState(input_value_json.fontSize);
  const [fontSizeType, setfontSizeType] = useState(
    input_value_json.fontSizeType || "px"
  );
  const [accentColor, setaccentColor] = useState(
    input_value_json.accentColor || ""
  );

  const [height, setheight] = useState(input_value_json.height || "");

  const [heightSizeType, setheightSizeType] = useState(
    input_value_json.heightSizeType || "px"
  );

  const [fontWeight, setfontWeight] = useState(
    input_value_json.fontWeight || "500"
  );
  const [color, setcolor] = useState(input_value_json.color);
  const [background, setbackground] = useState(input_value_json.background);
  const [borderRadius, setborderRadius] = useState(
    input_value_json.borderRadius
  );
  const [borderRadiusSizeType, setborderRadiusSizeType] = useState(
    input_value_json.borderRadiusSizeType || "px"
  );
  const [border, setborder] = useState(input_value_json.border);
  const [borderWidth, setborderWidth] = useState(input_value_json.borderWidth);
  const [borderWidthSizeType, setborderWidthSizeType] = useState(
    input_value_json.borderWidthSizeType || "px"
  );
  const [opacity, setopacity] = useState(input_value_json.opacity);
  const [borderColor, setborderColor] = useState(input_value_json.borderColor);
  const [width, setwidth] = useState(input_value_json.width);
  const [widthSizeType, setwidthSizeType] = useState(
    input_value_json.widthSizeType || "px"
  );
  const [lineHeight, setlineHeight] = useState(input_value_json.lineHeight);
  const [lineHeightSizeType, setlineHeightSizeType] = useState(
    input_value_json.lineHeightSizeType || "px"
  );

  const [fontStyle, setfontStyle] = useState(
    input_value_json.fontStyle || "unset"
  );
  const [textTransform, settextTransform] = useState(
    input_value_json.textTransform || "none"
  );

  const [marginTop, setmarginTop] = useState(input_value_json.marginTop);
  const [marginRight, setmarginRight] = useState(input_value_json.marginRight);
  const [marginBottom, setmarginBottom] = useState(
    input_value_json.marginBottom
  );
  const [marginLeft, setmarginLeft] = useState(input_value_json.marginLeft);
  const [marginSizeType, setmarginSizeType] = useState(
    input_value_json.marginSizeType || "px"
  );

  const [paddingTop, setpaddingTop] = useState(input_value_json.paddingTop);
  const [paddingRight, setpaddingRight] = useState(
    input_value_json.paddingRight
  );
  const [paddingBottom, setpaddingBottom] = useState(
    input_value_json.paddingBottom
  );
  const [paddingLeft, setpaddingLeft] = useState(input_value_json.paddingLeft);
  const [paddingSizeType, setpaddingSizeType] = useState(
    input_value_json.paddingSizeType || "px"
  );
  const [readyCssProperty, setreadyCssProperty] = useState(false);
  const [cssClassess, setcssClassess] = useState(input_value_string || "");


  function handleOpenClose() {
    props.handleOpenClose(index);
  }

  function handleReset() {
    const { input_default_value_json } = item;
    let defaultValue = input_default_value_json || {};

    setaccentColor(defaultValue.accentColor || "");
    setcolor(defaultValue.color || "");
    setfontSize(defaultValue.fontSize || "");
    setfontSizeType(defaultValue.fontSizeType || "px");
    setfontWeight(defaultValue.fontWeight || "");
    setfontStyle(defaultValue.fontStyle || "");
    settextTransform(defaultValue.textTransform || "");
    setopacity(defaultValue.opacity || "");

    setheight(defaultValue.height || "");
    setheightSizeType(defaultValue.heightSizeType || "px");

    setborderRadius(defaultValue.borderRadius || "");
    setborderColor(defaultValue.borderColor || "");
    setborderWidth(defaultValue.borderWidth || "");
    setborderWidthSizeType(defaultValue.borderWidthSizeType || "px");

    setborderRadiusSizeType(defaultValue.borderRadiusSizeType || "px");
    setborder(border || "");
    setbackground(defaultValue.background || "");
    setwidth(defaultValue.width || "");
    setwidthSizeType(defaultValue.widthSizeType || "px");
    setlineHeight(defaultValue.lineHeight || "");
    setlineHeightSizeType(defaultValue.lineHeightSizeType || "px");

    setmarginTop(defaultValue.marginTop);
    setmarginRight(defaultValue.marginRight);
    setmarginBottom(defaultValue.marginBottom);
    setmarginLeft(defaultValue.marginLeft || "");
    setmarginSizeType(defaultValue.marginSizeType || "px");

    setpaddingTop(defaultValue.paddingTop || "");
    setpaddingRight(defaultValue.paddingRight || "");
    setpaddingBottom(defaultValue.paddingBottom || "");
    setpaddingLeft(defaultValue.paddingLeft || "");
    setpaddingSizeType(defaultValue.paddingSizeType || "px");
  }

  function handleChange() {
    let value = {};
    if (input_value_json) {
      value = {
        ...input_value_json,
      };
    }
    value.accentColor = accentColor || "";
    value.color = color || "";
    value.fontSize = fontSize || "";
    value.fontSizeType = fontSizeType || "";
    value.fontWeight = fontWeight;
    value.fontStyle = fontStyle;
    value.textTransform = textTransform;
    value.opacity = opacity;

    value.borderRadius = borderRadius;
    value.borderColor = borderColor;
    value.borderWidth = borderWidth;
    value.borderWidthSizeType = borderWidthSizeType;

    value.borderRadiusSizeType = borderRadiusSizeType;
    value.border = border;
    value.background = background;
    value.width = width;
    value.widthSizeType = widthSizeType;
    value.height = height;
    value.heightSizeType = heightSizeType;
    value.lineHeight = lineHeight;
    value.lineHeightSizeType = lineHeightSizeType;

    value.marginTop = marginTop;
    value.marginRight = marginRight;
    value.marginBottom = marginBottom;
    value.marginLeft = marginLeft;
    value.marginSizeType = marginSizeType;

    value.paddingTop = paddingTop;
    value.paddingRight = paddingRight;
    value.paddingBottom = paddingBottom;
    value.paddingLeft = paddingLeft;
    value.paddingSizeType = paddingSizeType;
    props.handleChange(value);
  }
  function handleCssChange() {
    props.handleCssChange(cssClassess);
  }
  useEffect(() => {
    if (readyCssProperty) {
      handleCssChange();
    }
    setreadyCssProperty(true);
  }, [cssClassess]);

  useEffect(() => {
    if (ready) {
      handleChange();
    }
    setready(true);
  }, [
    accentColor,
    height,
    heightSizeType,
    color,
    fontSize,
    fontSizeType,
    fontWeight,
    fontStyle,
    textTransform,
    opacity,
    background,
    borderRadius,
    borderColor,
    borderWidth,
    borderWidthSizeType,
    borderRadiusSizeType,
    lineHeight,
    lineHeightSizeType,
    border,
    width,
    widthSizeType,
    marginTop,
    marginBottom,
    marginLeft,
    marginRight,
    marginSizeType,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingSizeType,
  ]);

  return (
    <div>
      <div
        style={{
          padding: "20px",
          margin:
            index === 0
              ? "-20px -20px 0 -20px"
              : index === 14 && !open
              ? "0 -20px -20px -20px"
              : "0 -20px 0 -20px",
          borderBottom: index == 14 || open ? "1px solid #ccc" : "",
          borderTop: index != 0 ? "1px solid #ccc" : "",
          cursor: "pointer",
        }}
        onClick={handleOpenClose}
      >
        <Stack alignment="center">
          <Stack.Item fill>
            <div style={{ fontWeight: 600, display: "flex" }}>
              <div>{name}</div>
            </div>
          </Stack.Item>
          {!hasFeature(item.key) && item.key == "edit_css_classes" ? (
            <UpgradeTooltip plan={getMinPlanForFeature(item.key)} />
          ) : null}
          <Stack.Item>
            {open ? (
              <Icon source={ChevronUpMinor} color="base" />
            ) : (
              <Icon source={ChevronRightMinor} color="base" />
            )}
          </Stack.Item>
        </Stack>
      </div>
      <Collapsible
        open={open}
        transition={{ duration: "100ms", timingFunction: "ease-in-out" }}
        expandOnPrint
      >
        <div style={{ padding: "10px" }}>
          {options.map((option, ind) => {
            let _option = null;

            if (option === "fontSize") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    Font Size
                  </div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <TextField
                      label="Font Size"
                      labelHidden
                      disabled={disabled}
                      value={fontSize}
                      onChange={(val) => {
                        setfontSize(val);
                      }}
                      autoComplete="off"
                      type="number"
                      align="right"
                    />
                  </div>
                  <div style={{ width: "70px" }}>
                    <Select
                      label=""
                      labelHidden
                      disabled={disabled}
                      options={sizeType}
                      onChange={(val) => {
                        setfontSizeType(val);
                      }}
                      value={fontSizeType}
                    />
                  </div>
                </Stack>
              );
            } else if (option === "opacity") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>Opacity</div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <TextField
                      label="Opacity"
                      labelHidden
                      disabled={disabled}
                      value={opacity}
                      type="decimal"
                      onChange={(val) => {
                        setopacity(val);
                      }}
                      autoComplete="off"
                      align="right"
                    />
                  </div>
                </Stack>
              );
            } else if (option === "borderRadius") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    Border Radius
                  </div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <TextField
                      label="Border Radius"
                      labelHidden
                      disabled={disabled}
                      value={borderRadius}
                      type="number"
                      onChange={(val) => {
                        setborderRadius(val);
                      }}
                      autoComplete="off"
                      align="right"
                    />
                  </div>
                  <div style={{ width: "70px" }}>
                    <Select
                      label=""
                      labelHidden
                      disabled={disabled}
                      options={sizeType}
                      onChange={(val) => {
                        setborderRadiusSizeType(val);
                      }}
                      value={borderRadiusSizeType}
                    />
                  </div>
                </Stack>
              );
            } else if (option === "borderWidth") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    Border Width
                  </div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <TextField
                      label="Border Width"
                      labelHidden
                      disabled={disabled}
                      value={borderWidth}
                      type="number"
                      onChange={(val) => {
                        setborderWidth(val);
                      }}
                      autoComplete="off"
                      align="right"
                    />
                  </div>
                  <div style={{ width: "70px" }}>
                    <Select
                      label=""
                      labelHidden
                      disabled={disabled}
                      options={sizeType}
                      onChange={(val) => {
                        setborderWidthSizeType(val);
                      }}
                      value={borderWidthSizeType}
                    />
                  </div>
                </Stack>
              );
            } else if (option === "letterSpacing") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    Letter Spacing
                  </div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <TextField
                      label="Font Size"
                      labelHidden
                      disabled={disabled}
                      value={letterSpacing}
                      onChange={() => {}}
                      autoComplete="off"
                      align="right"
                    />
                  </div>
                  <div style={{ width: "70px" }}>
                    <Select
                      label=""
                      labelHidden
                      disabled={disabled}
                      options={sizeType}
                      onChange={() => {}}
                      value={letterSpacingSizeType}
                    />
                  </div>
                </Stack>
              );
            } else if (option === "wordSpacing") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    Word Spacing
                  </div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <TextField
                      label="Word Spacing"
                      labelHidden
                      disabled={disabled}
                      value={wordSpacing}
                      onChange={() => {}}
                      autoComplete="off"
                      align="right"
                    />
                  </div>
                  <div style={{ width: "70px" }}>
                    <Select
                      label=""
                      labelHidden
                      disabled={disabled}
                      options={sizeType}
                      onChange={() => {}}
                      value={letterSpacingSizeType}
                    />
                  </div>
                </Stack>
              );
            } else if (option === "width") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>Width</div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <TextField
                      label="Width"
                      labelHidden
                      disabled={disabled}
                      value={width}
                      onChange={(val) => {
                        setwidth(val);
                      }}
                      autoComplete="off"
                      align="right"
                    />
                  </div>
                  <div style={{ width: "70px" }}>
                    <Select
                      label=""
                      labelHidden
                      disabled={disabled}
                      options={sizeType}
                      onChange={(val) => {
                        setwidthSizeType(val);
                      }}
                      value={widthSizeType}
                    />
                  </div>
                </Stack>
              );
            } else if (option === "height") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>Height</div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <TextField
                      label="height"
                      labelHidden
                      disabled={disabled}
                      value={height}
                      onChange={(val) => {
                        setheight(val);
                      }}
                      autoComplete="off"
                      align="right"
                    />
                  </div>
                  <div style={{ width: "70px" }}>
                    <Select
                      label=""
                      labelHidden
                      disabled={disabled}
                      options={sizeType}
                      onChange={(val) => {
                        setheightSizeType(val);
                      }}
                      value={heightSizeType}
                    />
                  </div>
                </Stack>
              );
            } else if (option === "lineHeight") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    Line Height
                  </div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <TextField
                      label="Line Height"
                      labelHidden
                      disabled={disabled}
                      type="number"
                      value={lineHeight}
                      onChange={(val) => {
                        setlineHeight(val);
                      }}
                      autoComplete="off"
                      align="right"
                    />
                  </div>
                  <div style={{ width: "70px" }}>
                    <Select
                      label=""
                      labelHidden
                      disabled={disabled}
                      options={sizeType}
                      onChange={(val) => {
                        setlineHeightSizeType(val);
                      }}
                      value={lineHeightSizeType}
                    />
                  </div>
                </Stack>
              );
            } else if (option === "fontWeight") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    Font Weight
                  </div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <Select
                      label="Font Weight"
                      labelHidden
                      disabled={disabled}
                      options={fontWeightOptions}
                      value={fontWeight}
                      onChange={(val) => {
                        setfontWeight(val);
                      }}
                    />
                  </div>
                </Stack>
              );
            } else if (option === "fontStyle") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    Font Style
                  </div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <Select
                      label="Font Weight"
                      labelHidden
                      disabled={disabled}
                      options={fontStyleOptions}
                      onChange={(val) => {
                        setfontStyle(val);
                      }}
                      value={fontStyle}
                    />
                  </div>
                </Stack>
              );
            } else if (option === "textAlign") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    Font Weight
                  </div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <Select
                      label="Font Weight"
                      labelHidden
                      disabled={disabled}
                      options={textAlignList}
                      onChange={() => {}}
                      value={textAlign}
                    />
                  </div>
                </Stack>
              );
            } else if (option === "accentColor") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    Accent Color
                  </div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <TextField
                      label="Accent Color"
                      labelHidden
                      disabled={disabled}
                      value={accentColor}
                      onChange={(val) => {
                        let value = val ? val.toLowerCase() : "";
                        setaccentColor(value);
                      }}
                      autoComplete="off"
                      align="right"
                    />
                  </div>
                  <LoopColorPicker
                    id="color"
                    color={accentColor}
                    changeColor={(val) => {
                      setaccentColor(val);
                    }}
                  />
                </Stack>
              );
            } else if (option === "color") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>Color</div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <TextField
                      label="Color"
                      labelHidden
                      disabled={disabled}
                      value={color}
                      onChange={(val) => {
                        let value = val ? val.toLowerCase() : "";
                        setcolor(value);
                      }}
                      autoComplete="off"
                      align="right"
                    />
                  </div>
                  <LoopColorPicker
                    id="color"
                    color={color}
                    changeColor={(val) => {
                      setcolor(val);
                    }}
                  />
                </Stack>
              );
            } else if (option === "background") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    Background
                  </div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <TextField
                      label="Background"
                      labelHidden
                      disabled={disabled}
                      value={background}
                      onChange={(val) => {
                        setbackground(val);
                      }}
                      autoComplete="off"
                      align="right"
                    />
                  </div>
                  <LoopColorPicker
                    id="background"
                    color={background}
                    changeColor={(val) => {
                      setbackground(val);
                    }}
                  />
                </Stack>
              );
            } else if (option === "borderColor") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    Border Color
                  </div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <TextField
                      label="Border Color"
                      labelHidden
                      disabled={disabled}
                      value={borderColor}
                      onChange={(val) => {
                        setborderColor(val);
                      }}
                      autoComplete="off"
                      align="right"
                    />
                  </div>
                  <LoopColorPicker
                    id="borderColor"
                    color={borderColor}
                    changeColor={(val) => {
                      setborderColor(val);
                    }}
                  />
                </Stack>
              );
            } else if (option === "border") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>Border</div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <TextField
                      label="Border"
                      labelHidden
                      disabled={disabled}
                      value={border}
                      onChange={(val) => {
                        setborder(val);
                      }}
                      autoComplete="off"
                      align="right"
                    />
                  </div>
                </Stack>
              );
            } else if (option === "margin") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>Margin</div>
                  <div class="loop-margin-panel">
                    <div style={{ marginRight: "3px", width: "40px" }}>
                      <TextField
                        label="Font Size"
                        labelHidden
                        disabled={disabled}
                        value={marginTop}
                        onChange={(val) => {
                          setmarginTop(val);
                        }}
                        autoComplete="off"
                        maxLength={5}
                        align="right"
                      />
                    </div>
                    <div style={{ marginRight: "3px", width: "40px" }}>
                      <TextField
                        label="Font Size"
                        labelHidden
                        disabled={disabled}
                        value={marginRight}
                        onChange={(val) => {
                          setmarginRight(val);
                        }}
                        autoComplete="off"
                        maxLength={5}
                        align="right"
                      />
                    </div>
                    <div style={{ marginRight: "3px", width: "40px" }}>
                      <TextField
                        label="Font Size"
                        labelHidden
                        disabled={disabled}
                        value={marginBottom}
                        onChange={(val) => {
                          setmarginBottom(val);
                        }}
                        autoComplete="off"
                        maxLength={5}
                        align="right"
                      />
                    </div>
                    <div style={{ marginRight: "3px", width: "40px" }}>
                      <TextField
                        label="Font Size"
                        labelHidden
                        disabled={disabled}
                        value={marginLeft}
                        onChange={(val) => {
                          setmarginLeft(val);
                        }}
                        autoComplete="off"
                        maxLength={5}
                        align="right"
                      />
                    </div>

                    <div style={{ width: "65px", fontSize: "12px" }}>
                      <Select
                        label=""
                        labelHidden
                        options={sizeType}
                        onChange={(val) => {
                          setmarginSizeType(val);
                        }}
                        value={marginSizeType}
                      />
                    </div>
                  </div>
                </Stack>
              );
            } else if (option === "padding") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>Padding</div>
                  <div class="loop-margin-panel">
                    <div style={{ marginRight: "3px", width: "40px" }}>
                      <TextField
                        label="Font Size"
                        labelHidden
                        disabled={disabled}
                        value={paddingTop}
                        onChange={(val) => {
                          setpaddingTop(val);
                        }}
                        autoComplete="off"
                        maxLength={5}
                        align="right"
                      />
                    </div>
                    <div style={{ marginRight: "3px", width: "40px" }}>
                      <TextField
                        label="Font Size"
                        labelHidden
                        disabled={disabled}
                        value={paddingRight}
                        onChange={(val) => {
                          setpaddingRight(val);
                        }}
                        autoComplete="off"
                        maxLength={5}
                        align="right"
                      />
                    </div>
                    <div style={{ marginRight: "3px", width: "40px" }}>
                      <TextField
                        label="Font Size"
                        labelHidden
                        disabled={disabled}
                        value={paddingBottom}
                        onChange={(val) => {
                          setpaddingBottom(val);
                        }}
                        autoComplete="off"
                        maxLength={5}
                        align="right"
                      />
                    </div>
                    <div style={{ marginRight: "3px", width: "40px" }}>
                      <TextField
                        label="Font Size"
                        labelHidden
                        disabled={disabled}
                        value={paddingLeft}
                        onChange={(val) => {
                          setpaddingLeft(val);
                        }}
                        autoComplete="off"
                        maxLength={5}
                        align="right"
                      />
                    </div>

                    <div style={{ width: "65px" }}>
                      <Select
                        label=""
                        labelHidden
                        disabled={disabled}
                        options={sizeType}
                        onChange={(val) => {
                          setpaddingSizeType(val);
                        }}
                        value={paddingSizeType}
                      />
                    </div>
                  </div>
                </Stack>
              );
            } else if (option === "wordBreak") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    Word Break
                  </div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <Select
                      label="Word Break"
                      labelHidden
                      disabled={disabled}
                      options={fontWeightOptions}
                      onChange={() => {}}
                      value={fontWeight}
                    />
                  </div>
                </Stack>
              );
            } else if (option === "textTransform") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    Text Transform
                  </div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <Select
                      label="Font Weight"
                      labelHidden
                      disabled={disabled}
                      options={textTransformOptions}
                      onChange={(val) => {
                        settextTransform(val);
                      }}
                      value={textTransform}
                    />
                  </div>
                </Stack>
              );
            } else if (option === "lineBreak") {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    Line Break{" "}
                  </div>
                  <div style={{ width: "110px", fontWeight: 500 }}>
                    <Select
                      label="Line Break"
                      labelHidden
                      disabled={disabled}
                      options={lineBreakOptions}
                      onChange={() => {}}
                      value={lineBreak}
                    />
                  </div>
                </Stack>
              );
            } else {
              _option = (
                <Stack key={ind} alignment="center">
                  <div style={{ width: "170px", fontWeight: 500 }}>
                    {option}
                  </div>
                </Stack>
              );
            }

            return (
              <div key={ind} style={{ padding: "10px 0" }}>
                {_option}
              </div>
            );
          })}
          {item.input_type === "JSON" ? (
            <div style={{ padding: "10px 0 10px 0" }}>
              <Stack>
                <div
                  style={{
                    cursor: "pointer",
                    textDecoration: "underline",
                    color: "blue",
                  }}
                  onClick={() => {
                    handleReset();
                  }}
                >
                  Reset to default settings
                </div>
              </Stack>
            </div>
          ) : null}
          {!options || !options.length ? (
            <Stack vertical={true}>
              <div style={{ fontWeight: 500 }}></div>
              <TextField
                label=""
                labelHidden
                placeholder="Add your own CSS code here to customize the appearance and layout of subscription widget."
                disabled={disabled}
                value={cssClassess}
                onChange={(val) => {
                  setcssClassess(val);
                }}
                multiline={15}
                maxHeight={400}
                autoComplete="off"
              />
            </Stack>
          ) : null}
        </div>
      </Collapsible>
    </div>
  );
}

export default StyleAccordion;
